export const environment = process.env.NEXT_PUBLIC_APP_ENV as string ?? 'local';

export const googleMapsApiKey = process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY as string;
export const baseApiUrl = process.env.NEXT_PUBLIC_API_BASE_URL as string;
export const intakeLink = process.env.NEXT_PUBLIC_INTAKE_LINK as string;
export const datadogClientToken = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN as string;
export const isDatadogEnabled = /^(true|1)$/i.test(process.env.NEXT_PUBLIC_DD_ENABLED ?? '');

export const appVersion = process.env.NEXT_PUBLIC_APP_VERSION as string;